<script setup lang="ts">
const { product, size = 'large' } = defineProps<{
  product: CrystallizeProduct
  size?: 'small' | 'large'
}>()
const { user } = useUserSession();
const card = useProductCard(product)
</script>

<template>
  <section
    class="bg-blurple-500 rounded-4xl px-m flex items-center gap-xl"
    :class="{
      'py-m md:px-xl': size === 'small',
      'py-xl md:py-2xl md:px-l': size === 'large',
    }"
  >
    <!-- TODO: Inverse colors -->
    <CrystallizeImage
      :image="card.illustration"
      class="hidden lg:block h-full w-full flex-1 aspect-square p-l"
    />
    <div class="flex-[3]">
      <div
        class="flex flex-col text-white"
        :class="{
          'gap-2xs': size === 'small',
          'gap-m': size === 'large',
        }"
      >
        <h2 class="text-blurple-300" v-text="card.title" />
        <!-- TODO: Get from CMS -->
        <p class="title-m">Alle rettsområder er inkludert i dette abonnementet</p>
        <p v-if="card.subtitle" v-text="card.subtitle" />
      </div>
      <Price
        v-if="card.variant"
        :price="card.variant"
        interval="yearly"
        class="text-white text-body inline-block"
        :class="{
          'mt-s': size === 'small',
          'mt-l': size === 'large',
        }"
        bold
        show-suffix
      />
      <div
        class="flex flex-wrap gap-s"
        :class="{
          'mt-m': size === 'small',
          'sm:gap-m md:gap-l mt-xl': size === 'large',
        }"
      >
        <Button
          v-if="isAdmin(user)"
          color="blurple"
          variant="primary"
          size="medium"
          :to="{
            name: 'info-page',
            params: {
              slug: 'kontakt-salgsavdelingen',
            },
          }"
        >
          Kontakt oss for tilbud
        </Button>
        <Button
          variant="secondary"
          :href="card.href"
          class="!text-white hover:!text-blurple-500"
          @click.prevent="navigateTo(card.href)"
        >
          Les mer
        </Button>
      </div>
    </div>
  </section>
</template>
